/**
 * ============================================================================
 * 🔀 Server-Konfiguration
 * ============================================================================
 * 
 * Alle Daten laufen über den eigenen Server (gepaeckannahme.de):
 * - Auth: Google OAuth + JWT
 * - Daten: PostgreSQL via REST API
 * - Sync: Polling + SSE (Server-Sent Events)
 * - Backups: Server-Dateisystem
 * - Drive: Token via Server Refresh
 * 
 * Was sich NICHT ändert:
 * - Google Drive API Calls (direkt, nur Token-Quelle vom Server)
 * - OCR / Vision API (via VPS /api/vision/)
 * - UI / Komponenten (identisch)
 * ============================================================================
 */

// 🌐 Server-URL (Nginx Reverse Proxy)
// /kiosk/ → wird auf dem Server zu /api/ gemappt
export const SERVER_URL = 'https://app.gepaeckannahme.de/kiosk';

// ⏱️ Request-Timeouts
export const REQUEST_TIMEOUT = 15000;    // 15 Sekunden für normale Requests
export const UPLOAD_TIMEOUT = 60000;     // 60 Sekunden für Uploads
export const SSE_RECONNECT_DELAY = 3000; // 3 Sekunden SSE-Reconnect

// 🔑 LocalStorage Keys für JWT-Tokens
export const TOKEN_KEYS = {
  ACCESS_TOKEN: 'kiosk_jwt_access',
  REFRESH_TOKEN: 'kiosk_jwt_refresh',
  USER_DATA: 'kiosk_user_data',
  TOKEN_EXPIRY: 'kiosk_token_expiry',
};
